export default Object.freeze({
  /*eslint-disable */
  PDF_FILE: 'JVBERi0',
  /*eslint-enable */
});
